<template>
  <login />
</template>

<script>
import login from '@/components/login';

export default {
  components: { login },
  data() {
    return {};
  },
  computed: {},
  methods: {},
  mounted() {}
};
</script>
